import { DateInput, Label, PhoneInput, TextInput } from 'components/Form'
import notification from 'helpers/notification'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import services from 'services/index'
import { defaultData } from '../constants'

const CreateForm = () => {
	const navigate = useNavigate()
	const [disabled, setDisabled] = useState(false)
	const [createData, setCreateData] = useState(defaultData)
	const {
		phone_number,
		birth_date,
		password,
		username,
		first_name,
		last_name,
	} = createData

	const createTeacher = () => {
		const options = {
			method: 'POST',
			data: createData,
			onStart: () => setDisabled(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setDisabled(false),
			onSuccess: response => {
				if (response?.status === 201) {
					setCreateData(defaultData)
					navigate('/account/teachers')
					notification("O'qituvchi muvaffaqiyatli yaratildi!", {
						type: 'success',
					})
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.teachers.createTeachers(options)
	}
	return (
		<div className='pt-6'>
			<div className='grid grid-cols-12 gap-4 mb-6'>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Ism</Label>
					<TextInput
						size='small'
						value={first_name}
						onChange={first_name =>
							setCreateData({ ...createData, first_name })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Familiya</Label>
					<TextInput
						size='small'
						value={last_name}
						onChange={last_name => setCreateData({ ...createData, last_name })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Tug'ilgan sana</Label>
					<DateInput
						size='small'
						value={birth_date}
						onChange={birth_date =>
							setCreateData({ ...createData, birth_date })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Login</Label>
					<TextInput
						size='small'
						value={username}
						onChange={username => setCreateData({ ...createData, username })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Parol</Label>
					<TextInput
						size='small'
						value={password}
						onChange={password => setCreateData({ ...createData, password })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Telefon raqami</Label>
					<PhoneInput
						size='small'
						value={phone_number}
						onChange={phone_number =>
							setCreateData({ ...createData, phone_number })
						}
					/>
				</div>
			</div>
			<div className='flex justify-center sm:justify-end mt-4'>
				<button
					disabled={disabled}
					className='success-btn w-full sm:w-auto'
					onClick={createTeacher}
				>
					O'qituvchi yaratish
				</button>
			</div>
		</div>
	)
}

export default CreateForm
